import { NgForm } from '@angular/forms';
import { ViewChild, Output, EventEmitter } from '@angular/core';

export class BaseFormComponent {
    @ViewChild('form') public form: NgForm;

    @Output() public added = new EventEmitter();
    @Output() public removed = new EventEmitter();
    @Output() public updated = new EventEmitter();
    

    // Form operation type
    public operation: 'create' | 'update';

    // Form component loading flag
    public isLoading: boolean = false;

}
